import { render, staticRenderFns } from "./StudentIndicator.vue?vue&type=template&id=76023628&scoped=true"
import script from "./StudentIndicator.vue?vue&type=script&lang=js"
export * from "./StudentIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76023628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76023628')) {
      api.createRecord('76023628', component.options)
    } else {
      api.reload('76023628', component.options)
    }
    module.hot.accept("./StudentIndicator.vue?vue&type=template&id=76023628&scoped=true", function () {
      api.rerender('76023628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/StudentIndicator.vue"
export default component.exports